import type { AssistantContextValue } from './types'

import React from 'react'

export const AssistantContext = React.createContext<AssistantContextValue>({
	isBusy: false,
	agent_url: undefined,
	avaliableAgents: [],
	agent: undefined,
	messages: [],
	setAgent: () => {},
	sendMessage: () => {},
	resetConversation: () => {},
	messageReaction: () => {},
})
